module.exports = __webpack_public_path__ + "img/c05_buildingtechbolster_Normal_ua.19095b80.webp";